import { addressGateBeet } from '@metaplex-foundation/mpl-candy-guard';
import { createSerializerFromBeet } from '../../../types/Serializer.mjs';

/**
 * The addressGate guard restricts the mint to a single
 * address which must match the minting wallet's address.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const addressGateGuardManifest = {
  name: 'addressGate',
  settingsBytes: 32,
  settingsSerializer: createSerializerFromBeet(addressGateBeet)
};

export { addressGateGuardManifest };
//# sourceMappingURL=addressGate.mjs.map
